import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const StyledButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    columnGap: '1rem',
    marginTop: '2rem'
})
